////////LIBRARY/////////
import React, { useState, useEffect, useRef } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import styled from 'styled-components'
import { isUndefined, reject, cloneDeep, map, find, filter } from 'lodash'
///////COMPONENTS///////
import {
	InputLogin,
	SearchInputButton,
	SearchInputWrapper,
	PageGridTitle,
	PageGridBorder,
	SearchReset,
	ShiftItemButton,
} from '../../../theme/GlobalCss'
import ToggleFilters from '../../Ui/ToggleFilters'
import ListSearchable from '../../../components/ListSearchable'
import TooltipHelp from '../../TooltipHelp'

/////////STYLED/////////
const StaticPerimeterWrapper = styled.div``
const KioskSearchWrapper = styled.div`
	position: relative;
	& > * > input {
		font-size: ${(props) => props.theme.font.fs};
	}
	display: flex;
	flex-direction: row;
`
const ListActions = styled.div`
	position: relative;
	padding: 10px;
	display: flex;
	flex-direction: row;
	&:nth-child(2) {
		border-bottom: 1px solid ${(props) => props.theme.colors.TabNav.border};
	}
`
const RowsSelectedCounterWrapper = styled.div`
	margin-left: auto;
`
const RowsSelectedCounter = styled.span`
	font-weight: bold;
	color: ${(props) => props.theme.colors.primary};
`
const ListEditableRedux = styled.div`
	& > div > div > div {
		margin: 0px;
		border: 0px;
		padding: 0px 23px;
	}
	& > div > div > div > * {
		margin: 0px 7px;
	}
`
const ListSearchableCheckAllWrapper = styled.div`
	display: flex;
	align-items: center;
`
const ListSearchableInput = styled.input`
	margin-right: 19px;
`
const ListSearchableCheckAllLabel = styled.label`
	font-weight: bold;
`
/////////STYLED/////////

const StaticPerimeter = (props) => {
	const { user, translations } = useSelector(
		(state) => ({
			user: state.user,
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	const [inputData, setInputData] = useState(props.baseData)
	const [checkedNivSort, setCheckedNivSort] = useState(false)
	const [sortColumnName, setSortColumnName] = useState('labelToDisplay')
	const [sortDir, setSortDir] = useState(1)
	const [searchValue, setSearchValue] = useState('')
	const [searched, setSearched] = useState('')

	const [baseSearch, setBaseSearch] = useState() // Database of searching

	const refListKiosks = useRef()

	const [allData, setAllData] = useState()

	const [checkedAll, setCheckedAll] = useState(false)

	/*
	position: absolute;
	top: -40px;
	left: 50%;
	transform: translateX(-50%);
	padding: 11px 0px;
	border: 0px;
}
	*/

	///////////////////////////////// CONFIG ///////////////////////////////////////

	const config = {
		name: translations['page__scopeManagement__static_kiosk_selection'],
		filters: {
			searchValue: searched,
		},
		noStandardFilters: true,
		multipleColumnsSearchable: true,
	}

	const columns = [
		// We set what data value is used to
		// For setting value of input
		{ isCheckboxValue: true, dataHook: 'id', headerName: 'id', sortable: false },
		// For labelling the item
		{
			isLabel: true,
			dataHook: 'labelToDisplay',
			headerName: 'labelToDisplay',
			sortable: true,
			alreadyTranslated: true,
			className: 'separateLabel',
		},
		{ isLabel: true, dataHook: 'model', headerName: 'model', sortable: true, alreadyTranslated: true, className: 'separateLabel' },
	]

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleInputData = (triggerShift, arrToPass) => {
		let newinputData = cloneDeep(inputData)

		// Every item that was in affected list (checked items), we add to this list
		if (props.listObjAffected.length > 0) {
			map(props.listObjAffected, (elem, id) => {
				if (!isUndefined(elem)) {
					const r = filter(newinputData, (o) => o.id === elem?.id)
					// If affected item is not in our current list, we add it
					return r.length === 0 ? newinputData.push(elem) : null
				}
			})
		}
		// But also cutting objects that were shifted,
		// at any time so filters can work properly
		if (triggerShift) {
			map(arrToPass, (elem) => {
				newinputData = reject(newinputData, elem)
			})
			// Send items to affected manager
			props.setListObjUnaffected(arrToPass)
			// Reset checked list
			props.setListUnaffected([])
		}
		setInputData(newinputData)
		// Everytime that items are added / remove, we redraw the search base
		setBaseSearch(newinputData)
	}

	const handleSearchValue = (e) => {
		setSearchValue(e.target.value)
	}

	const handleSearch = (_e) => {
		setSearched(searchValue)
	}

	const handleSearchEnter = (e) => {
		if (e.keyCode === 13 || searchValue === '') setSearched(searchValue)
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		// Whenever we change filters we redraw the list
		handleInputData()
	}, [props.baseData, props.listObjAffected])

	useEffect(() => {
		// We need to reject all kiosks that are already in seleciton result
		let arr = user.identity.kiosksPool

		map(props.listKiosksSelected, (elem) => {
			arr = reject(arr, (o) => o.id === elem)
		})

		setInputData(arr)
		setAllData(user.identity.kiosksPool)
	}, [user, props.listKiosksSelected])

	useEffect(() => {
		checkedNivSort ? setSortColumnName('model') : setSortColumnName('labelToDisplay')
	}, [checkedNivSort])

	useEffect(() => {
		handleGlobalSearch()
	}, [searched])

	const handleListObjUnaffected = () => {
		let arrToPass = []
		let r
		map(props.listUnaffected, (elem) => {
			// We want to push objects, not ids,
			// so we are searching on all data available, unaffected and affected !
			r = find(allData, (o) => o.id === elem)
			if (!isUndefined(r)) {
				arrToPass.push(r)
			}
		})
		handleInputData(true, arrToPass)
	}
	// Handling of filters
	const handleGlobalSearch = () => {
		// Note that we always start from searchBase, not current input,
		// Otherwise everytime we are filtering, we are removing elements !
		if (!isUndefined(baseSearch)) {
			let b_s = cloneDeep(baseSearch)
			if (searchValue.length > 0) {
				b_s = reject(b_s, (o) => {
					let str = cloneDeep(o.labelToDisplay)
					str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
					let transformed_search = cloneDeep(searched)
					transformed_search = transformed_search.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
					return str.toUpperCase().includes(transformed_search.toUpperCase()) ? false : true
				})
			}
			setInputData(b_s)
		}
	}

	const handleCheckAll = (_checkedAll) => {
		if (_checkedAll) {
			props.setListUnaffected(map(inputData, 'id'))
		} else {
			props.setListUnaffected([])
		}
		setCheckedAll(_checkedAll)
	}

	useEffect(() => {
		// If all elements are selected (by a check all for example)
		// and that we uncheck one item, we uncheck "Checked All"
		if (props.listUnaffected.length < inputData.length) setCheckedAll(false)
	}, [props.listUnaffected])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<StaticPerimeterWrapper>
			<div>
				<TooltipHelp content={'tooltipHelp__admin__modal__body__scopeManagement__resultSelection'} insideModal>
					<PageGridTitle>{config.name}</PageGridTitle>
				</TooltipHelp>
				<PageGridBorder>
					<ListActions>
						<KioskSearchWrapper>
							<SearchInputWrapper>
								<InputLogin
									value={searchValue}
									onChange={handleSearchValue}
									onKeyDown={handleSearchEnter}
									placeholder={translations['page__tagManagement__kiosk_search']}
								/>
								<SearchInputButton onClick={handleSearch} />
							</SearchInputWrapper>
							{searchValue.length > 0 && (
								<SearchReset
									onClick={() => {
										setSearchValue('')
										setSearched('')
									}}
								/>
							)}
						</KioskSearchWrapper>
					</ListActions>
					<ListActions>
						<ToggleFilters
							checked={checkedNivSort}
							onChangeHandler={() => {
								setCheckedNivSort(!checkedNivSort)
							}}
							name="columnSort"
							labelPrev={translations['modal__kioskScope__admin__kioskScope__statiqueMode__switchNameCode_name']}
							labelNext={translations['modal__kioskScope__admin__kioskScope__statiqueMode__switchNameCode_code']}
						/>
						<ToggleFilters
							checked={sortDir}
							onChangeHandler={() => {
								setSortDir(sortDir === 0 ? 1 : 0)
							}}
							name="columnSort"
							sortPics
						/>
						<ListSearchableCheckAllWrapper>
							<ListSearchableInput
								type="checkbox"
								checked={checkedAll}
								onClick={() => {
									handleCheckAll(!checkedAll)
								}}
							/>
							<ListSearchableCheckAllLabel>{translations['page__roleManagement__roleSheet_allChecked']}</ListSearchableCheckAllLabel>
						</ListSearchableCheckAllWrapper>
						<RowsSelectedCounterWrapper>
							<RowsSelectedCounter>
								{!isUndefined(props.listUnaffected) ? props.listUnaffected.length : 0} / {inputData.length}
							</RowsSelectedCounter>{' '}
							{translations['page__tagManagement__kiosk_selected']}
						</RowsSelectedCounterWrapper>
					</ListActions>
					<ListEditableRedux>
						{props.baseData && (
							<ListSearchable
								inputData={inputData}
								inputColumns={columns}
								sortColumnName={sortColumnName}
								sortDir={sortDir}
								translationMode={true}
								inputConfig={config}
								sizeHeightActions={310}
								ref={refListKiosks}
								hookList={props.setListUnaffected}
								summaryList={props.listUnaffected}
								fixedBaseHeight={750}
								remoteCheckAll={checkedAll}
								remoteCheckAllFunc={handleCheckAll}
							/>
						)}
					</ListEditableRedux>
					<ShiftItemButton
						onClick={() => props.listUnaffected.length > 0 && handleListObjUnaffected()}
						active={props.listUnaffected.length > 0}
					>
						{translations['page__scopeManagement__static_kiosk_addToScope']}
					</ShiftItemButton>
				</PageGridBorder>
			</div>
		</StaticPerimeterWrapper>
	)
}

StaticPerimeter.propTypes = {}

StaticPerimeter.defaultPropTypes = {}

export default StaticPerimeter
